import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function AnimatedStat({
  end,
  suffix = '',
  prefix = '',
  label
}: {
  end: number;
  suffix?: string;
  prefix?: string;
  label: string;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  useEffect(() => {
    if (!isInView) return;
    let startTime: number;
    const duration = 2; // seconds
    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = (timestamp - startTime) / (duration * 1000);
      if (progress < 1) {
        setCount(Math.floor(end * progress));
        requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };
    requestAnimationFrame(animate);
  }, [end, isInView]);
  return <div ref={ref} className="text-center relative z-10" data-id="element-199">
      <div className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-gold mb-2" data-id="element-200">
        {prefix}
        {count}
        {suffix}
      </div>
      <div className="text-white/90 font-medium text-sm md:text-base uppercase tracking-wider" data-id="element-201">
        {label}
      </div>
    </div>;
}
export function ImpactStats() {
  return <section className="relative py-24 border-y border-white/10 overflow-hidden" data-id="element-202">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1521737711867-e3b97375f902?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=90)'
    }} data-id="element-203"></div>
      <div className="absolute inset-0 bg-brand-navy/90 mix-blend-multiply" data-id="element-204"></div>
      <div className="absolute inset-0 bg-brand-navy/80" data-id="element-205"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-206">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8" data-id="element-207">
          <AnimatedStat end={25} suffix="+" label="Years Experience" data-id="element-208" />
          <AnimatedStat end={150} prefix="$" suffix="M+" label="Saved for Clients" data-id="element-209" />
          <AnimatedStat end={500} suffix="K+" label="Claims Managed" data-id="element-210" />
          <AnimatedStat end={1.2} suffix="M+" label="Provider Network" data-id="element-211" />
        </div>
      </div>
    </section>;
}